// @ts-strict-ignore
import React from 'react'
import { View } from 'react-native'
import Modal from 'react-native-modal'

import { ResponsiveScrollView } from 'APP/Converse/Layout'
import Button from 'APP/Converse/Button'
import Typography from 'APP/Converse/Typography'

import I18n from 'APP/I18n'
import { Images } from 'APP/Themes'
import styled, { useTheme } from 'styled-components/native'
import useScreenView from 'APP/Hooks/useScreenView'

const StyledModal = styled(View)`
  background-color: ${({ theme }) => theme.colors.background};
  border-radius: ${({ theme }) => theme.metrics.borderRadius.medium}px;
  width: 500px;
  height: 400px;
  max-width: 100%;
  max-height: 100%;
  align-self: center;
  align-items: center;
  padding-bottom: ${({ theme }) => (theme.isSmallScreen ? theme.metrics.baseMargin / 2 : 0)}px;
`

const StyledHeader = styled(View)`
  display: flex;
  flex-direction: row;
  align-self: flex-end;
`

const StyledTitle = styled(Typography)`
  text-align: center;
`

interface QRCodeAppModalProps {
  isVisible: boolean
  onClose: () => void
}

export const QRCodeAppModal = ({ isVisible, onClose }: QRCodeAppModalProps) => {
  const theme = useTheme()
  const { isSmallScreen } = useScreenView()

  const contentContainerInnerStyle = {
    paddingLeft: theme.metrics.baseMargin,
    paddingRight: theme.metrics.baseMargin,
    alignItems: 'center',
    gap: theme.metrics.baseMargin,
  }

  return (
    <Modal
      statusBarTranslucent
      isVisible={isVisible}
      animationIn="zoomIn"
      animationOut="zoomOut"
      testID="QR_CODE_APP_MODAL"
      // had to use inline style because we can't override default margins using the RN styled-components
      style={{ margin: theme.metrics.baseMargin }}
    >
      <StyledModal>
        <StyledHeader>
          <Button
            variant="tertiary"
            analyticsName="WelcomeScreen.downloadApp"
            icon="close"
            iconPosition="right"
            iconVariant="material"
            widthVariant="circle"
            onPress={onClose}
            testID="QR_CODE_APP_MODAL_CLOSE_BUTTON"
            accessibilityLabel={I18n.t('QRCodeAppModal.closeButtonAccessibilityLabel') || undefined}
          />
        </StyledHeader>
        <ResponsiveScrollView contentContainerInnerStyle={contentContainerInnerStyle}>
          <StyledTitle variant="h1">{I18n.t('QRCodeAppModal.title')}</StyledTitle>
          <Typography variant="bodyNormal">{I18n.t('QRCodeAppModal.subtitle')}</Typography>

          <Images.qrCodeAppStore
            width={isSmallScreen ? 150 : 200}
            height={isSmallScreen ? 150 : 200}
          />
        </ResponsiveScrollView>
      </StyledModal>
    </Modal>
  )
}
